<template>
  <div class="dashboard">
    <Breadcrumbs :items="breadcrumbs" />    

    <div class="content">
      <div class="router-view">
        <GoogleMap v-if="googleHospitals.length > 0" :hospitals="googleHospitals" :key="updateMap" :clickOnHospital="onRowClick" />

        <rp-table
          :results="getHospitals"
          :headings="[
            {heading: 'Hospital / Clinic', key: 'name'},
            'country',
            {heading: 'City', key: 'town'},
            {heading: 'Address', key: 'address_1'},
            {heading: 'Region', key: 'county'}]"
          @rowClick="onRowClick">
        </rp-table>
        <router-view/>
      </div>

      <div class="actions">
        <rp-permissions :requireAll="['read_users', 'write_users']">
          <router-link to="/users/add-user" class="action-panel">
            <span class="panel-icon"><i class="material-icons">person_add</i></span>
            <h2>Add a user</h2>
          </router-link>
        </rp-permissions>

        <rp-permissions :requireAll="['write_user_hospitals']">
          <router-link to="/hospitals/add-hospital" class="action-panel">
            <span class="panel-icon"><i class="material-icons">add_location</i></span>
            <h2>Add a hospital</h2>
          </router-link>
        </rp-permissions>

        <router-link to="/messages" class="action-panel">
          <span class="panel-icon"><i class="material-icons">message</i></span>
          <h2>All Messages</h2>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import Breadcrumbs from '@/components/Breadcrumbs'
import GoogleMap from '@/components/GoogleMap'
import Table from 'raypro_ui/src/components/ui/Table'
import page from '@/mixins/page'
import Permissions from 'raypro_ui/src/components/Permissions'
import {mapGetters} from 'vuex'

import {getHospitals} from 'raypro_ui/src/api/hospitals'
// import {getUserHospitals} from 'raypro_ui/src/api/users'

export default {
  components: {
    Breadcrumbs,
    GoogleMap,
    'rp-permissions': Permissions,
    'rp-table': Table
  },

  mixins: [page],

  data() {
    return {
      googleHospitals: [],
      updateMap: 0,
      page: {
        totalPages: 1,
        totalEntries: 0,
        pageSize: 10,
        pageNumber: 1
      },
      breadcrumbs: [
        {label: 'All Hospitals'}
      ],
      title: 'All Hospitals'
    }
  },

  computed: {...mapGetters(['isDistributor', 'authUser'])},

  methods: {
    onRowClick(row) {
      this.$router.push({name: 'view-hospital', params: {id: row.id}})
    },

    getHospitals(page) {
      // let hospitalsEndPoint
      // let payload

      // uncomment if you want scoping for the distributor
      // if(this.isDistributor) {
      //   payload = {
      //     id: this.authUser.id,
      //     page: page
      //   }
      //   hospitalsEndPoint = (dataObject) => { return getUserHospitals(dataObject) }
      // } else {
      const payload = page

      const hospitalsEndPoint = (page) => { return getHospitals(page) }
      // }

      return hospitalsEndPoint(payload).then(({data, page}) => {
        const mapped = data.map((row) => {
          return {
            'id': row.id,
            'name': row.name,
            'country': row.country.name,
            'town': row.town,
            'address_1': row.address_1,
            'county': row.county,
            'latitude': row.latlng && row.latlng[0],
            'longitude': row.latlng && row.latlng[1]
          }
        })

        this.googleHospitals = mapped.filter((el) => {
          return el.latitude !== null && el.longitude !== null
        })

        this.updateMap++

        return {
          data: mapped,
          page
        }
      })
    }
  }
}
</script>

<style lang="sass">
  @import 'raypro_ui/src/styles/base/_variables.sass'
  @import 'raypro_ui/src/styles/helpers/_mixins.sass'
  @import '../../../stylesheets/helpers/extends'
</style>



// WEBPACK FOOTER //
// src/components/pages/Hospitals/Hospitals.vue